import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-map-popup',
  templateUrl: './map-popup.component.html',
  styleUrls: [],
})
export class MapPopupComponent {
  @Input() data: any;
  @Output() closeEvent = new EventEmitter();
  @Output() openLampDetail = new EventEmitter();
  @Output() closeLampDetail = new EventEmitter();
  @Output() updateCheckbox = new EventEmitter();
  @Output() updatePopup = new EventEmitter();
}
